import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import crudApi from "@serie3/common/api/crudApi";
import { ProfileConfig } from "@serie3/common/Modules/Profile/Resources/Endpoints";
import { Container, Row, Col } from "react-bootstrap";
import PricingSection from "../shared/Pricing/PricingSection";

const Plans = () => {
  const { t } = useTranslation();
  const [paymentId, setPaymentId] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      const response = await crudApi.justGet(ProfileConfig.endpoints.settingsget);
      if (response.ok) {
        setPaymentId(response.data.Settings[0].payment_id);
      }
    };
    loadData();
  }, []);

  return (
    <Container fluid>
      <Row>
        <Col>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">{t("Plans.Header")}</h4>
          </div>
        </Col>
      </Row>
      <PricingSection
        paymentId={paymentId}
        stripeUrl="https://buy.stripe.com/test_dRm6oH7K2bPccme4ge83C01"
      />
    </Container>
  );
};

export default Plans;
